import { render, staticRenderFns } from "./EconomyReports.vue?vue&type=template&id=4bd3bb17&scoped=true"
import script from "./EconomyReports.vue?vue&type=script&lang=js"
export * from "./EconomyReports.vue?vue&type=script&lang=js"
import style0 from "./EconomyReports.vue?vue&type=style&index=0&id=4bd3bb17&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bd3bb17",
  null
  
)

export default component.exports